import * as Sentry from '@sentry/angular';

export function createErrorHandler() {
  return new ChunkLoadingErrorHandler();
}
export class ChunkLoadingErrorHandler extends Sentry.SentryErrorHandler {
  constructor() {
    super();
  }

  handleError(error): void {
    if (error && /ailed to fetch dynamically imported module/i.test(error.message)) {
      alert(
        'Ett fel uppstod vid hämtning av en modul. Detta kan bero på att modulen inte är tillgänglig eller att det finns ett problem med nätverksanslutningen. Försök att ladda om sidan.'
      );
      return;
    }

    super.handleError(error);
  }
}
